import React, { useState, useEffect } from "react";
import { Divider, message, Card, Typography, Space, Button } from "antd";
import {
	BulbOutlined,
	FileUnknownOutlined,
	FormOutlined,
	UserOutlined,
	MailOutlined,
	PhoneOutlined,
	DownloadOutlined,
} from "@ant-design/icons";
import dayjs from "dayjs";
import http from "../../../../../services/http";
import { useNavigate } from "react-router-dom";
const { Text } = Typography;

const titulo = {
	[1]: (
		<Text>
			<BulbOutlined /> Sugestão de Inovação ou Melhoria
		</Text>
	),
	[2]: (
		<Text>
			<FileUnknownOutlined /> Como Implantar
		</Text>
	),
	[3]: (
		<Text>
			<FormOutlined /> Retorno Enviado
		</Text>
	),
	[4]: (
		<Text>
			<FormOutlined /> Retorno Recebido
		</Text>
	),
};
export const SugestaoDetalhes = ({ idSugestao }) => {
	const [loading, setLoading] = useState(false);
	const { navigate } = useNavigate();

	const [dadosSugestao, setDadosSugestao] = useState(null);
	const [mensagens, setMensagens] = useState([]);
	const [colaboradores, setColaboradores] = useState([]);

	useEffect(() => {
		if (idSugestao > 0) {
			listarMensagens(idSugestao);
			listarColaboradores(idSugestao);
			carregarSugestao(idSugestao);
		}
	}, [idSugestao]);

	// LISTAR COLABORADORES
	const listarColaboradores = async (id_sugestao) => {
		setLoading(true);
		const api = await http("get", `v1/sugestoes_colaboradores/listar/${id_sugestao}`, []);
		if (api.statusCode === 200) {
			setColaboradores(api?.response?.data);
		} else {
			message.error(api.response.message);
		}
		setLoading(false);
	};

	// CARREGAR SUGESTÃO
	const carregarSugestao = async (id) => {
		if (!id) return;
		setLoading(true);
		const api = await http("get", `v1/sugestoes/carregar/${id}`, []);
		if (api.statusCode === 200) {
			setDadosSugestao(api.response.data);
		} else {
			message.error(api.response.message);
			navigate("/sugestoes-recebidas");
		}
		setLoading(false);
	};

	// CARREGAR MENSAGENS
	const listarMensagens = async (id) => {
		if (!id) return;
		setLoading(true);
		const api = await http("get", `v1/sugestoes_mensagens/listar/${id}`, []);
		if (api.statusCode === 200) {
			setMensagens(api?.response?.data);
		} else {
			message.error(api.response.message);
			navigate("/sugestoes-recebidas");
		}
		setLoading(false);
	};

	// DOWNLOAD RELATÓRIO
	const baixarRelatorio = async (id) => {
		if (!id) return;
		setLoading(true);
		const api = await http("file", `v1/sugestoes/relatorio/${id}`, []);
		if (api.statusCode === 200) {
			// DOWNLOAD FILE
			const url = window.URL.createObjectURL(api?.response?.data);
			let a = document.createElement("a");
			a.href = url;
			a.download = "relatorio.pdf";
			a.click();
		} else {
			message.error(api.response.message);
			navigate("/sugestoes-recebidas");
		}
		setLoading(false);
	};

	return (
		<div>
			<Space direction="vertical" size={0}>
				<Text type="secondary" style={{ fontSize: 12 }}>
					Título
				</Text>
				<Text strong style={{ fontSize: 14 }}>
					{dadosSugestao?.titulo}
				</Text>
			</Space>

			<Divider />
			<Space direction="vertical" style={{ width: "100%" }} size={20}>
				{mensagens.map((m, index) => {
					return (
						<Card size="small" title={titulo[m?.tipo]} style={{ width: "100%" }} key={index}>
							<Text type="secondary" style={{ fontSize: 11, fontWeight: 500 }}>
								{dayjs(m?.data_lancamento).format("DD/MM/YYYY")}
							</Text>
							<div
								className={`content-sugestao-text ${m.tipo === 3 ? "line-break" : ""}`}
								dangerouslySetInnerHTML={{ __html: m.texto }}
							/>
						</Card>
					);
				})}

				<Card
					size="small"
					title={
						<Text>
							<UserOutlined /> Colaboradores
						</Text>
					}
					style={{ width: "100%" }}>
					<Space direction="vertical" size={0}>
						{colaboradores?.map((c, index) => {
							return (
								<Text key={index} style={{ fontSize: 14 }}>
									{c?.matricula ?? "-"} - {c?.nome ?? "-"}
								</Text>
							);
						})}
					</Space>
				</Card>

				<Card
					size="small"
					title={
						<Text>
							<UserOutlined /> Contato
						</Text>
					}
					style={{ width: "100%" }}>
					<Space direction="vertical" size={0}>
						<Text type="secondary" style={{ fontSize: 12 }}>
							<PhoneOutlined /> Celular
						</Text>
						<Text strong style={{ fontSize: 14 }}>
							{dadosSugestao?.telefone ?? "-"}
						</Text>

						<Text type="secondary" style={{ fontSize: 12 }}>
							<MailOutlined /> E-mail
						</Text>
						<Text strong style={{ fontSize: 14 }}>
							{dadosSugestao?.email ?? "-"}
						</Text>
					</Space>
				</Card>

				<Space wrap>
					<Button icon={<DownloadOutlined />} onClick={() => baixarRelatorio(idSugestao)}>
						Download
					</Button>
				</Space>
			</Space>
		</div>
	);
};
